import getMailTips from '../selectors/getMailTips';
import MailTipsCacheEntry from '../store/schema/MailTipsCacheEntry';
export interface MemberCountInfo {
    TotalMemberCount: number;
    ExternalMemberCount: number;
}
export default function getMemberCountInfo(
    fromAddress: string,
    recipientAddress: string
): MemberCountInfo {
    const mailTips = getMailTips();
    const cacheEntry: MailTipsCacheEntry = mailTips.get(fromAddress, recipientAddress);
    if (cacheEntry) {
        return {
            TotalMemberCount: cacheEntry.value.TotalMemberCount,
            ExternalMemberCount: cacheEntry.value.ExternalMemberCount,
        };
    } else {
        return null;
    }
}
